import axios from 'axios'

const API_PATH = 'api/v2/admins/cms/homepages/sections'

const CmsHomepageSectionApiV2 = {

  /**
   * Get list of Cms Homepage Sections
   * Invoke `GET api/v2/admins/cms/homepages/sections'
   */
  get: async () => {
    const path = API_PATH

    const response = await axios.get(path, { })
    return response
  },

  /**
   * Get Cms Homepage Section and Content
   * Invoke `GET api/v2/admins/cms/homepages/sections/:id'
   * @param {string} id - id of section
   */
  show: async (id) => {
    const path = `${API_PATH}/${id}`

    const response = await axios.get(path, { })
    return response
  },

  /**
   * Get Cms Homepage Section and Content
   * Invoke `GET api/v2/admins/cms/homepages/sections/:id'
   * @param {string} id - id of section
   * @param {object} values - values of all params get from form
   */
  putSection: async (id, payload) => {
    const path = `${API_PATH}/${id}`

    const response = axios.put(path, payload)

    return response
  }
}

export default CmsHomepageSectionApiV2
